module.exports = __webpack_public_path__ + "media/images/emblems/Hausen_am_Albis-blazon-484a804796e53dee01df9012078aa1dd.svg";